import { render } from "./MyInfo.vue?vue&type=template&id=7b98e9ca"
import script from "./MyInfo.vue?vue&type=script&lang=js"
export * from "./MyInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__